// 邮箱
export const isEmail = (s) => {
  return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(
    s,
  );
};

// 手机号码
export const isMobile = (s) => {
  return /^1[0-9]{10}$/.test(s);
};

// 是否是纯数字
export const isNumber = (o) => {
  return /^\d+$/.test(o);
  // return Object.prototype.toString.call(o).slice(8, -1) === 'Number';
};
// 是否是正整数
export const isInt = (o) => {
  return /(^[1-9]\d*$)/.test(o);
  // return Object.prototype.toString.call(o).slice(8, -1) === 'Number';
};

// 严格的身份证校验
export const isCardID = (sId) => {
  if (!/(^\d{15}$)|(^\d{17}(\d|X|x)$)/.test(sId)) {
    console.log('你输入的身份证长度或格式错误');
    return false;
  }
  //身份证城市
  const aCity = {
    11: '北京',
    12: '天津',
    13: '河北',
    14: '山西',
    15: '内蒙古',
    21: '辽宁',
    22: '吉林',
    23: '黑龙江',
    31: '上海',
    32: '江苏',
    33: '浙江',
    34: '安徽',
    35: '福建',
    36: '江西',
    37: '山东',
    41: '河南',
    42: '湖北',
    43: '湖南',
    44: '广东',
    45: '广西',
    46: '海南',
    50: '重庆',
    51: '四川',
    52: '贵州',
    53: '云南',
    54: '西藏',
    61: '陕西',
    62: '甘肃',
    63: '青海',
    64: '宁夏',
    65: '新疆',
    71: '台湾',
    81: '香港',
    82: '澳门',
    91: '国外',
  };
  if (!aCity[parseInt(sId.substr(0, 2), 10)]) {
    console.log('你的身份证地区非法');
    return false;
  }

  // 出生日期验证
  const sBirthday = (
      sId.substr(6, 4) +
      '-' +
      Number(sId.substr(10, 2)) +
      '-' +
      Number(sId.substr(12, 2))
    ).replace(/-/g, '/'),
    d = new Date(sBirthday);
  if (
    sBirthday !==
    d.getFullYear() + '/' + (d.getMonth() + 1) + '/' + d.getDate()
  ) {
    console.log('身份证上的出生日期非法');
    return false;
  }

  // 身份证号码校验
  let sum = 0,
    weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2],
    codes = '10X98765432';
  for (let i = 0; i < sId.length - 1; i++) {
    sum += sId[i] * weights[i];
  }
  let last = codes[sum % 11]; //计算出来的最后一位身份证号码
  if (sId[sId.length - 1] !== last) {
    console.log('你输入的身份证号非法');
    return false;
  }

  return true;
};
//简单网址校验
export function isUrl(url) {
  return /^https?:\/\/.+/.test(url);
}

export const positionStrLen = (str) => {
  if (!str) {
    return 0;
  }
  let count = 0; //初始化字节数递加变量并获取字符串参数的字符个数
  for (let i = 0; i < str.length; i++) {
    //遍历字符串，枚举每个字符
    if (str.charCodeAt(i) > 255) {
      //字符编码大于255，说明是双字节字符(即是中文)
      count += 2; //则累加2个
    } else {
      count++; //否则递加一次
    }
  }
  return count; //返回字节数
};
//计算字节数
export const validateStrLen = (str) => {
  if (!str) {
    return 0;
  }
  let count = 0; //初始化字节数递加变量并获取字符串参数的字符个数
  for (let i = 0; i < str.length; i++) {
    //遍历字符串，枚举每个字符
    if (str.charCodeAt(i) > 255) {
      //字符编码大于255，说明是双字节字符(即是中文)
      count += 2; //则累加2个
    } else {
      count++; //否则递加一次
    }
  }
  return count; //返回字节数
};

/**
 * 校验消费金额规则
 * @param {Array} isSendCouponList - 优惠券规则列表
 * @returns {Object} - 返回校验结果，包含是否通过和错误信息
 */
export function validateCouponRules(isSendCouponList) {
  // 如果列表为空，直接返回通过
  if (!isSendCouponList || isSendCouponList.length === 0) {
    return { valid: true };
  }

  // 检查每条规则的上下限关系
  for (let i = 0; i < isSendCouponList.length; i++) {
    const rule = isSendCouponList[i];
    const minAmount = Number(rule.minAmount);
    const maxAmount = Number(rule.maxAmount);

    // 校验规则①：下限必须小于等于上限
    if (minAmount > maxAmount) {
      return {
        valid: false,
        message: `规则${i + 1}的金额下限(${minAmount})大于上限(${maxAmount})`,
        index: i,
      };
    }
  }

  // 对列表按照下限金额排序
  const sortedList = [...isSendCouponList].sort(
    (a, b) => Number(a.minAmount) - Number(b.minAmount),
  );

  // 检查规则间是否有重叠
  for (let i = 0; i < sortedList.length - 1; i++) {
    const currentRule = sortedList[i];
    const nextRule = sortedList[i + 1];

    const currentMax = Number(currentRule.maxAmount);
    const nextMin = Number(nextRule.minAmount);

    // 校验规则②：检查是否有重叠部分
    // 精确到小数点后两位，所以最小间隔是0.01
    if (nextMin <= currentMax) {
      // 找到原始索引，便于定位问题
      const currentIndex = isSendCouponList.findIndex(
        (item) => item.id === currentRule.id,
      );
      const nextIndex = isSendCouponList.findIndex(
        (item) => item.id === nextRule.id,
      );

      return {
        valid: false,
        message: `规则${currentIndex + 1}的上限(${currentMax})与规则${
          nextIndex + 1
        }的下限(${nextMin})存在重叠，下限应大于${currentMax}`,
        index1: currentIndex,
        index2: nextIndex,
      };
    }
  }

  return { valid: true };
}
